import React from 'react'
import { getCommonnessTier } from '../../lib/getCommonnessTier'

// 'label' — bars + the friendly tier name.
// 'meter' — bars only; the tier name moves into a hover tooltip, for rows too
//    tight to carry it (components and related words).
type CommonnessChipDisplay = 'label' | 'meter'

type Props = {
   // 0–1 commonness of the word.
   commonnessScore: number
   display?: CommonnessChipDisplay
}

const CHIP_BARS = 5

// A compact commonness pill: five micro-bars on the single marigold ramp (the
// rare floor fills grey, never coral/red) plus the tier name. Reused on the
// component and related-word rows (both meter-only).
const CommonnessChip = ({ commonnessScore, display = 'label' }: Props) => {
   const { level, label, description } = getCommonnessTier(commonnessScore)
   const filled = level + 1
   const isRare = level === 0

   return (
      <span className="group relative inline-flex items-center gap-[6px] bg-chipBg border border-chipBorder rounded-[6px] px-[8px] py-[3px] text-[11.5px] font-bold text-bodyGray tabular-nums flex-none">
         <span className="inline-flex gap-[1.5px]">
            {Array.from({ length: CHIP_BARS }).map((_, index) => (
               <i
                  key={index}
                  className="block w-[3.5px] h-[8px] rounded-[1px]"
                  style={{
                     background:
                        index < filled
                           ? isRare
                              ? 'var(--color-textMuted)'
                              : 'var(--color-commonness)'
                           : 'var(--color-barEmpty)',
                  }}
               />
            ))}
         </span>
         {display === 'label' && label}
         {display === 'meter' && (
            <span
               // Right-aligned rather than centred on the chip: every meter chip
               // is the trailing element of its row, so a centred tooltip hangs
               // half its width past the row's right edge — which the suggest
               // panel then clips (it is overflow-hidden for its rounded
               // corners) and its scroller turns into horizontal scroll.
               className="absolute bottom-[calc(100%+6px)] right-0 z-10 flex flex-col gap-[2px] w-max max-w-[180px] p-[6px_9px] rounded-[6px] bg-bodyBlack text-pageBg text-[11px] font-medium leading-[1.35] text-left normal-case opacity-0 pointer-events-none transition-opacity duration-150 group-hover:opacity-100"
               role="tooltip"
            >
               <b className="font-bold">{label}</b>
               {description}
            </span>
         )}
      </span>
   )
}

export default CommonnessChip
